// extracted by mini-css-extract-plugin
module.exports = {"root":"PatternAutocomplete_root__3-eoh","list":"PatternAutocomplete_list__1ygiQ"};